export function AboutSection() {
  return (
    <section id="sobre" className="pt-8 pb-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
            <i className="ri-hospital-line"></i>
            <span>Sobre a Nova Imagem</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Tecnologia e Humanização em Diagnóstico
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Combinamos equipamentos de última geração com uma equipe médica altamente especializada para oferecer diagnósticos precisos e atendimento acolhedor.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center mb-16">
          <div className="relative h-64 sm:h-80 lg:h-[500px] rounded-3xl overflow-hidden shadow-2xl">
            <img
              src="https://static.readdy.ai/image/060e1c25caffef29cb7917b5a22faf7c/a7158e59eb338e20326c5ca7b4b40047.jpeg"
              alt="Equipe médica especializada"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-900/30 to-transparent"></div>
          </div>

          <div className="space-y-8">
            <div className="flex items-start space-x-4">
              <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-microscope-line text-2xl text-blue-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Equipamentos de Última Geração</h3>
                <p className="text-gray-600 leading-relaxed">
                  Investimos constantemente em tecnologia de ponta para garantir imagens de alta qualidade e diagnósticos mais precisos. Nossos equipamentos são atualizados regularmente seguindo os mais altos padrões internacionais.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-team-line text-2xl text-teal-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Equipe Médica Especializada</h3>
                <p className="text-gray-600 leading-relaxed">
                  Nossos médicos radiologistas possuem ampla experiência e especialização em diagnóstico por imagem. Cada laudo é elaborado com atenção aos detalhes e compromisso com a excelência médica.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-heart-line text-2xl text-blue-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Atendimento Humanizado</h3>
                <p className="text-gray-600 leading-relaxed">
                  Entendemos que realizar exames pode gerar ansiedade. Por isso, nossa equipe está preparada para oferecer um atendimento acolhedor, com atenção especial a todos os nossos pacientes.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8">
          <div className="bg-gradient-to-br from-blue-50 to-teal-50 p-8 rounded-2xl text-center">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
              <i className="ri-shield-check-line text-3xl text-blue-600"></i>
            </div>
            <h4 className="text-lg font-bold text-gray-900 mb-2">Segurança</h4>
            <p className="text-gray-600 text-sm">Protocolos rigorosos de segurança e higiene</p>
          </div>

          <div className="bg-gradient-to-br from-blue-50 to-teal-50 p-8 rounded-2xl text-center">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
              <i className="ri-time-line text-3xl text-blue-600"></i>
            </div>
            <h4 className="text-lg font-bold text-gray-900 mb-2">Agilidade</h4>
            <p className="text-gray-600 text-sm">Resultados rápidos e precisos</p>
          </div>

          <div className="bg-gradient-to-br from-blue-50 to-teal-50 p-8 rounded-2xl text-center">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
              <i className="ri-star-line text-3xl text-blue-600"></i>
            </div>
            <h4 className="text-lg font-bold text-gray-900 mb-2">Qualidade</h4>
            <p className="text-gray-600 text-sm">Selo de Qualidade do Colégio Brasileiro de Radiologia</p>
          </div>

          <div className="bg-gradient-to-br from-blue-50 to-teal-50 p-8 rounded-2xl text-center">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
              <i className="ri-hand-heart-line text-3xl text-blue-600"></i>
            </div>
            <h4 className="text-lg font-bold text-gray-900 mb-2">Cuidado</h4>
            <p className="text-gray-600 text-sm">Atendimento personalizado e acolhedor</p>
          </div>
        </div>
      </div>
    </section>
  );
}
